/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Referral_Code_CopiedInputs */

const en_mobile_referral_code_copied = /** @type {(inputs: Mobile_Referral_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Referral code copied`)
};

const es_mobile_referral_code_copied = /** @type {(inputs: Mobile_Referral_Code_CopiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código de referido copiado`)
};

/**
* | output |
* | --- |
* | "Referral code copied" |
*
* @param {Mobile_Referral_Code_CopiedInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_referral_code_copied = /** @type {((inputs?: Mobile_Referral_Code_CopiedInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Referral_Code_CopiedInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_referral_code_copied(inputs)
	return en_mobile_referral_code_copied(inputs)
});